"use strict";

const TreatmentStepsCtrl = function ($state, PatientsService, FileSaver, Notification) {
    var ctrl = this;


    ctrl.addTreatmentStep = function(){
      if(!ctrl.treatment){
        PatientsService.addTreatment(ctrl.patient.pid).then(function(data){
          ctrl.patient.treatments = data.data.treatments;
          ctrl.treatment = ctrl.patient.treatments[ctrl.patient.treatments.length -1];
          $state.go('main.patients.list.details.treatform',{patient: ctrl.patient, treatment: ctrl.treatment});
        });
      }else{
        $state.go('main.patients.list.details.treatform',{patient: ctrl.patient, treatment: ctrl.treatment});
      }
    };

    ctrl.editForm = function(patient, treatment, action){
      PatientsService.getTreatmentForm(treatment.uuid, action.uuid).then(function(response){
        $state.go('main.patients.formview', {
          schema: response.data,
          data: action.data,
          treatment: treatment,
          action: action,
          actionId: action.uuid,
          treatId: treatment.uuid,
          patient: patient,
          pid: patient.pid});
      });
    };

    ctrl.getInterventionProtocol = function(treatUuid, actionUuid){
      PatientsService.getInterventionProtocol(treatUuid, actionUuid).then(function(data){
        var file = new Blob([data.data], {type: 'application/pdf'});
        FileSaver.saveAs(file, "Interventionsprotokoll-" + ctrl.patient.pid + ".pdf");
      }, function(){
        Notification.error("Die angeforderte Datei konnte nicht abgerufen werden.");
      });
    };

    ctrl.requestDeletion = function(item){
      item.popover = false;
      console.info("foo");
      PatientsService.addTreatmentActionDeletionRequest({
        'treatUuid': ctrl.treatment.uuid,
        'actionUuid': item.uuid,
        'comment': ctrl.deleteMsg
      }).then(
        function(){
          Notification.success('Ihr Löschantrag wurde erfolgreich eingereicht und wird nun von dem Datentreuhänder bearbeitet.');
          ctrl.deleteMsg = undefined;
        },
        function(error){
          if(error.status === 409){
            Notification.info('Es wurde bereits ein Löscheintrag für diesen Behandlungsschritt eingereicht.');
          }else{
            Notification.error('Beim Einreichen des Löschantrags ist ein Fehler aufgetreten.');
          }
          ctrl.deleteMsg = undefined;
        });
    };
  };

TreatmentStepsCtrl.$inject = ['$state', 'PatientsService', 'FileSaver', 'Notification'];

module.exports = {
  template: require('./treatsteps.html'),
  bindings: {
    patient: '<',
    treatment: '<'
  },
  controller: TreatmentStepsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/tile-treatment-steps/treatment-steps.component.js